module.exports = __webpack_public_path__ + "3cf699df215fdde9ae51482f93a29677.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/herbal-peel/ingredients/lemon-balm.jpg
 ** module id = 452
 ** module chunks = 0
 **/